module.exports = __webpack_public_path__ + "static/media/7-vrt.2a15ced7.mp3";